import { createSelector } from '@reduxjs/toolkit';

import { selectUserLicensesMap } from '@/domain/auth/auth.selectors.ts';
import { LicenseMode } from '@/domain/auth/entities/user.entity.ts';
import { RootState } from '@/domain/store';

export const selectProjectVenuesItems = (state: RootState) => {
  return state.projectVenue.items;
};

export const selectCurrentProjectVenue = (state: RootState) => {
  return state.projectVenue.current;
};

export const selectIsFetchingProjectsVenue = (state: RootState) => {
  return state.projectVenue.isFetchingProjects;
};

export const selectIsCreatingProjectVenue = (state: RootState) => {
  return state.projectVenue.isCreatingProject;
};

export const selectIsEditingProjectVenue = (state: RootState) => {
  return state.projectVenue.isEditingProject;
};

export const selectProjectVenuesItemsLength = (state: RootState) => {
  return state.projectVenue.items.length;
};

export const checkUserCreateVenue = createSelector(
  [selectProjectVenuesItemsLength, selectUserLicensesMap],
  (nbProjectVenue, userLicensesMap) => {
    const licenseFound = userLicensesMap.get(LicenseMode.VENUE);
    return licenseFound && licenseFound.nbProjects > nbProjectVenue;
  },
);
